import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _ from 'lodash';
import { timer, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { fadeInOut } from '../animations';

/** Still used on Internal Admin and Integrations Dashboard pages. */
@Component({
  selector: 'zbp-fallback-download',
  templateUrl: './fallback-download.component.html',
  styleUrls: ['./fallback-download.component.scss'],
  animations: [fadeInOut],
  standalone: false
})
export class FallbackDownloadComponent implements OnInit {
  id: string = '';
  url: SafeUrl = '';
  filename: string = '';
  target: string = '';
  visible = false;
  private pattern: RegExp;

  @Input() displayIcon = false;
  @Input() idPrefix: string = 'fallbackDownload';
  @Input() classes: string = '';
  @Input() downloadPrompt: string = 'If the file download did not start automatically, ';
  @Input() downloadLinkText: string = 'please click here';
  @Output() clicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @ViewChild('link', { static: true }) link: ElementRef<HTMLAnchorElement>;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.pattern = new RegExp(window.location.host);
    this.id = _.uniqueId(this.idPrefix);
  }

  linkClicked(): void {
    this.clicked.emit(true);
  }

  get ariaState(): string {
    return this.visible ? 'false' : 'true';
  }

  get defaultClasses(): string {
    const visibility = this.visible ? 'Visible' : 'Hidden';
    return `fallbackDownload fallbackDownload${visibility} ${this.classes}`;
  }

  startDownload(url: string, filename: string): Observable<boolean> {
    const sameOrigin = this.pattern.test(url);
    this.url = this.sanitizer.bypassSecurityTrustUrl(url);
    this.filename = sameOrigin ? filename : '';
    this.target = !sameOrigin ? '_blank' : '';
    this.visible = true;

    return timer(500)
      .pipe(map(() => {
        this.link.nativeElement.focus();
        this.link.nativeElement.click();
        return true;
      }));
  }
}
